import { render, staticRenderFns } from "./AFPTable.vue?vue&type=template&id=747a614c&"
import script from "./AFPTable.vue?vue&type=script&lang=js&"
export * from "./AFPTable.vue?vue&type=script&lang=js&"
import style0 from "./AFPTable.vue?vue&type=style&index=0&id=747a614c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports